import _ from 'lodash'

const replacer = (key: string, value: any) => (value === null ? '' : value) // specify how you want to handle null values here
export const jsonListToCSV = (
    items: any[] = [],
    customHeader = Object.keys(items?.[0]) ?? []
) => {
    const csv = [
        customHeader.join(','), // header row first
        ...items.map((row) =>
            customHeader
                .map((fieldName) => {

                    const value = row[fieldName]
                    // FIXME better date heuristic
                    if (
                        fieldName?.includes('time') ||
                        fieldName?.includes('date')
                    ) {
                        return value.toString()
                    }
                    const stringified = JSON.stringify(value, null, 2);
                    const quote = stringified?.includes(',')? '"' : '';
                    const escaped = stringified.replace(/"/g, '""')
                    return `${quote}${escaped}${quote}`
                })
                .join(',')
        ),
    ].join('\r\n')
    return csv
}

export const jsonArrayToCSV = (items: string[][], customHeader: string[]) => {
    const csv = [
        customHeader.join(','), // header row first 
        ...items.map((row) => row.join(',')),
    ].join('\r\n')
    return csv
}

const flattenPropertiesInner = (
    acc: Record<string, string>,
    currentValue?: Object,
    basePath = '',
    skipEmpty = false
) => {
    if (_.isObject(currentValue)) {
        const pairs = _.toPairs(currentValue)
        pairs.forEach((p) =>
            flattenPropertiesInner(
                acc,
                p[1],
                (basePath ? basePath + '.' : '') + String(p[0])
            )
        )
    } else if (!skipEmpty || !_.isEmpty(currentValue)) {
        acc[basePath] =  String(currentValue) // leaf
    }
}

export const flattenProperties = (
    currentValue?: Object,
    skipEmpty = false
): Record<string, string> => {
    const result: Record<string, string> = {}
    flattenPropertiesInner(result, currentValue, '', skipEmpty)
    return result
}

export function downloadCSV(filename: string, text: string) {
    const aDom = document.createElement('a')
    aDom.setAttribute(
        'href',
        'data:text/csv;charset=utf-8,' + encodeURIComponent(text)
    )
    aDom.setAttribute('download', filename)
    aDom.style.display = 'none'
    document.body.appendChild(aDom)
    aDom.click()
    document.body.removeChild(aDom)
}

export function downloadTXT(filename: string, text: any) {
    const aDom = document.createElement('a')
    aDom.setAttribute(
        'href',
        'data:text;charset=utf-8,' + encodeURIComponent(text)
    )
    aDom.setAttribute('download', filename)
    aDom.style.display = 'none'
    document.body.appendChild(aDom)
    aDom.click()
    document.body.removeChild(aDom)
}
export function downloadAny(filename: string, url: any) {
    const aDom = document.createElement('a')
    aDom.href = url;
    aDom.setAttribute('download', filename)
    aDom.style.display = 'none'
    document.body.appendChild(aDom)
    aDom.click()
    // link.parentNode.removeChild(link);
    document.body.removeChild(aDom)
}